var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrocurrent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EBD5C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 37.0535L35.8133 22.6668C35.9036 22.5812 35.9643 22.4691 35.9867 22.3468C36.0264 22.2255 36.0264 22.0947 35.9867 21.9735C35.9422 21.8513 35.8576 21.7479 35.7467 21.6801C35.6441 21.6112 35.5235 21.5741 35.4 21.5735H25.1333L27.8 11.6268C27.8404 11.492 27.8404 11.3483 27.8 11.2135C27.7403 11.0815 27.6429 10.9701 27.52 10.8935C27.3933 10.8262 27.2493 10.7983 27.1067 10.8135C26.9683 10.8427 26.8398 10.907 26.7333 11.0001L12.1867 25.3335C12.0964 25.419 12.0357 25.5311 12.0133 25.6535C11.9736 25.7747 11.9736 25.9055 12.0133 26.0268C12.0578 26.1489 12.1424 26.2524 12.2533 26.3201C12.3558 26.3891 12.4764 26.4262 12.6 26.4268H22.8667L20.2 36.3735C20.1596 36.5083 20.1596 36.652 20.2 36.7868C20.2597 36.9188 20.3571 37.0301 20.48 37.1068C20.6067 37.174 20.7507 37.2019 20.8933 37.1868C21.0497 37.1848 21.2022 37.1386 21.3333 37.0535Z",
    fill: "#B0654D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2133 17.0398L35.68 12.5732",
    stroke: "#B0654D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3066 36.0001L16.7733 31.5334",
    stroke: "#B0654D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrocurrent);
export default __webpack_public_path__ + "static/media/microcurrent.740b4d96039a097c5780780a2c3f8222.svg";
export { ForwardRef as ReactComponent };